import { Pipe, PipeTransform } from '@angular/core';
import { Estudo } from '../../pages/estudos-cientificos/estudos-cientificos.modelview';

/**
 * Generated class for the EstudosFiltroPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'estudosFiltro',
})
export class EstudosFiltroPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: Array<Estudo>, ...args) {
    if (value != undefined) {
      let key = args[0].key
      let especialidade = args[0].esp

      if (especialidade != undefined && especialidade != "Selecione") {
        value = value.filter(it => {

          if (it.tags != undefined)
            return it.tags.indexOf(especialidade) >= 0
          else return false
        })
      }

      if (key != undefined) {
        let filtredByName = value.filter((it) => { return it.titulo.toLocaleLowerCase().indexOf(key.toLocaleLowerCase()) >= 0 })

        let filtredByTags = []

        value.map((it) => {
          if (it.tags != undefined) {
            let filtredByTagsOfThis = it.tags.filter((it) => { return it.toLocaleLowerCase().indexOf(key.toLocaleLowerCase()) >= 0 })
            if (filtredByTagsOfThis.length > 0) {
              filtredByTags.push(it)
            }
          }
        })

        if (filtredByTags != undefined)
          filtredByTags.map((it) => {
            if (filtredByName.indexOf(it) < 0)
              filtredByName.push(it)
          })

        return filtredByName

      }
      return value
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/estudos-filtro/estudos-filtro.ts